import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IMei, { MeiLogisticOperatorStatus } from "Types/IMei";
import _ from "lodash";
import ResultModel from "models/ResultModel";

export const GET_MEIS = "[MEI] GET_MEIS";
export const GET_MEIS_SUCCESS = "[MEI] GET_MEIS_SUCCESS";
export const GET_MEIS_FAILED = "[MEI] GET_MEIS_FAILED";

export const IMPORT_MEIS = "[MEI] IMPORT_MEIS";
export const IMPORT_MEIS_SUCCESS = "[MEI] IMPORT_MEIS_SUCCESS";
export const IMPORT_MEIS_FAILED = "[MEI] IMPORT_MEIS_FAILED";

export const SEND_MEIS = "[MEI] SEND_MEIS";
export const SEND_MEIS_SUCCESS = "[MEI] SEND_MEIS_SUCCESS";
export const SEND_MEIS_FAILED = "[MEI] SEND_MEIS_FAILED";

export const CHANGE_MEI_OL_STATUS = "[MEI] CHANGE_MEI_OL_STATUS";
export const CHANGE_MEI_OL_STATUS_SUCCESS =
	"[MEI] CHANGE_MEI_OL_STATUS_SUCCESS";
export const CHANGE_MEI_OL_STATUS_FAILED = "[MEI] CHANGE_MEI_OL_STATUS_FAILED";

export const SET_VALUE = "[MEI] SET_VALUE";
export const CLEAR_VALUES = "[MEI] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function importMei(data: any[], callback?: Callback<IMei[]>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: IMPORT_MEIS });

		try {
			const { login } = getState();

			const chunks = _.chunk(data, 100);

			let response: Response | any = null;

			const models: any[] = [];

			for (const chunk of chunks) {
				response = await api.sendPost("/Mei/Import", chunk, {
					Authorization: `Bearer ${login.token}`
				});

				const result: ResultModel<any[]> = await response.json();

				models.push(...(result.model || []));
			}

			dispatch({
				type: IMPORT_MEIS_SUCCESS,
				payload: models
			});

			callback && callback(null, models);
		} catch (error) {
			return dispatch({
				type: IMPORT_MEIS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function send(
	id: string | string[],
	sendEmail: boolean,
	sendWhatsApp: boolean,
	callback?: Callback<any>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: SEND_MEIS });

		try {
			const { login } = getState();

			let response: Response;
			if (Array.isArray(id)) {
				response = await api.sendPost(
					`/Mei/Send`,
					{ id, sendEmail, sendWhatsApp },
					{
						Authorization: `Bearer ${login.token}`
					}
				);
			} else {
				response = await api.sendPost(
					`/Mei/${id}/Send`,
					{
						sendEmail,
						sendWhatsApp
					},
					{
						Authorization: `Bearer ${login.token}`
					}
				);
			}

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: SEND_MEIS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: SEND_MEIS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: SEND_MEIS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getMeis(
	skip?: number,
	take: number = 10,
	filter?: any[] | any,
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<IMei[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_MEIS });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Mei?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_MEIS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_MEIS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_MEIS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getMeisForLogisticOperator(callback?: Callback<IMei[]>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_MEIS });

		try {
			const { login } = getState();

			const response = await api.sendGet("/Mei/LogisticOperator", {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_MEIS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_MEIS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_MEIS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function changeLogisticOperatorStatus(
	id: string,
	status: MeiLogisticOperatorStatus,
	callback?: Callback<MeiLogisticOperatorStatus>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CHANGE_MEI_OL_STATUS });

		try {
			const { login } = getState();

			const response = await api.sendPut(
				`/User/${id}/logisticOperator/Status/${status}`,
				null,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: CHANGE_MEI_OL_STATUS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: CHANGE_MEI_OL_STATUS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: CHANGE_MEI_OL_STATUS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
